import { datadogRum } from '@datadog/browser-rum'
import { defineNuxtPlugin } from '#app'

function asPercentage(value: unknown, fallback: number) {
    const parsed = Number(value)
    return Number.isFinite(parsed) ? Math.min(100, Math.max(0, parsed)) : fallback
}

export default defineNuxtPlugin((nuxtApp) => {
    const {
        datadogApplicationId,
        datadogClientToken,
        datadogVersion,
        datadogEnv,
        datadogSampleRate,
    } = nuxtApp.$config.public

    if (!datadogApplicationId || !datadogClientToken) {
        return
    }

    const sampleRate = asPercentage(datadogSampleRate, 25)
    datadogRum.init({
        applicationId: datadogApplicationId,
        clientToken: datadogClientToken,
        site: 'datadoghq.com',
        service: 'thorne-frontend',
        version: datadogVersion ?? '1.0.0',
        env: datadogEnv ?? 'unknown',
        sessionSampleRate: sampleRate,
        sessionReplaySampleRate: 100,
        traceSampleRate: sampleRate,
        allowedTracingUrls: [window.location.origin],
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        compressIntakeRequests: true,
        proxy: options => `/dd_metrics${options.path}?${options.parameters}`,
    })

    nuxtApp.hook('vue:error', (error, _instance, info) => {
        datadogRum.addError(error, {
            source: 'vue',
            info,
            route: nuxtApp.$router.currentRoute.value.path,
        })
    })

    nuxtApp.hook('app:error', (error) => {
        datadogRum.addError(error, {
            source: 'nuxt',
            route: nuxtApp.$router.currentRoute.value.path,
        })
    })

    datadogRum.startSessionReplayRecording()
})
